import type { RecordField } from '@k12/app-components';

const refundField = (key: string, label: string): RecordField => ({
  key,
  label,
  type: 'currency',
  fractionDigits: 2,
  readonly: true,
  showWhen: { field: key, is: 'not-null' }
});

export const CW_REFUND_FIELDS: RecordField[] = [
  refundField('cwFallRefundDue', 'Fall CW Refund Due'),
  refundField('cwSpringRefundDue', 'Spring CW Refund Due'),
  refundField('cwFallRefunded', 'Fall CW Refunded'),
  refundField('cwSpringRefunded', 'Spring CW Refunded')
];
